import { Injectable} from '@angular/core';

import { ListingParams, EmailData } from '../_models/common/listingParams';
//import { Notification } from '../_models/notification/toastr-notification.model';  
@Injectable()
export class DataPassService {
  
  public printParams = {} as  ListingParams;
  public emailData = {} as EmailData;
  public notification = {} as  Notification;
  public listingParams = {} as ListingParams;
  public passdata: any;
  public isQuickMenuOpen = true;
 

  constructor(
  ) {
  }

}
